module.exports = __webpack_public_path__ + "static/img/nhjd.1a9fdea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nhjd.png
// module id = o2oA
// module chunks = 1